import React from "react";
import { Spacing } from "spacing/component";
import { SpaceName } from "../../types";

export const with7XS = withSpace("7xs");
export const with6XS = withSpace("6xs");
export const with5XS = withSpace("5xs");
export const with4XS = withSpace("4xs");
export const with3XS = withSpace("3xs");
export const with2XS = withSpace("2xs");
export const withXS = withSpace("xs");
export const withS = withSpace("s");
export const withM = withSpace("m");
export const withL = withSpace("l");
export const withXL = withSpace("xl");
export const with2XL = withSpace("2xl");
export const with3XL = withSpace("3xl");
export const with4XL = withSpace("4xl");
export const with5XL = withSpace("5xl");
export const with6XL = withSpace("6xl");
export const with7XL = withSpace("7xl");

function withSpace(spaceName: SpaceName) {
  return (previous: any, current: any) => (
    <React.Fragment>
      {previous}
      <Spacing pt={spaceName} />
      {current}
    </React.Fragment>
  );
}
